import { render, staticRenderFns } from "./BViewTemplateTradeComparison.vue?vue&type=template&id=69527956&scoped=true"
import script from "./BViewTemplateTradeComparison.vue?vue&type=script&lang=js"
export * from "./BViewTemplateTradeComparison.vue?vue&type=script&lang=js"
import style0 from "./BViewTemplateTradeComparison.vue?vue&type=style&index=0&id=69527956&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69527956",
  null
  
)

export default component.exports